import {useGetReviewsTotalQuery} from 'modules/product-card/services';
import {getDefaultReviewsTotalParams} from 'modules/products/helpers';

const REVIEWS_TOTAL_DEFAULTS = {
    reviewsCount: 0,
    assessmentsCount: 0,
    tasteTags: [],
    assessments: [
        {title: 5, count: 0},
        {title: 4, count: 0},
        {title: 3, count: 0},
        {title: 2, count: 0},
        {title: 1, count: 0},
    ],
};

export const useReviewsTotal = ({code}: {code: string}) => {
    const {data: total} = useGetReviewsTotalQuery(getDefaultReviewsTotalParams(code));

    if (!total) {
        return REVIEWS_TOTAL_DEFAULTS;
    }

    return total;
};
